export default (that) => [
  {
    field: 'seq',
    width: 60,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    field: 'defaultImageUrl',
    width: 70,
    title: that.$l('table_label_image') || '图片',
    headerAlign: 'left',
    align: 'center',
    fixed: 'left',
    slots: { default: 'defaultImageUrl' },
  },
  {
    title: that.$l('table_label_displaySku') || '产品',
    field: 'goodsName',
    minWidth: 250,
    fixed: 'left',
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displaySku' },
  },
  {
    title: that.$l('table_label_displayWarehouse') || '仓库',
    field: 'warehouseDesc',
    minWidth: 250,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayWarehouse' },
  },
  {
    title: that.$l('table_label_displayWarehouseInv') || '仓库库存',
    field: 'warehouseInv',
    minWidth: 250,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayWarehouseInv' },
    isTotalColumn: true,
    totalColumnKey: 'platformSellable',
    totalFormatter: ({ column, total }) => {
      const { totalColumnKey } = column
      const value = that.format(total[totalColumnKey])
      return `${that.$l('table_label_sellable') || '可售数量'}: ${value || '0'}`
    },
  },
  {
    title: that.$l('table_label_displaySellable') || '出货信息',
    field: 'sellable',
    minWidth: 250,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displaySellable' },
  },
  {
    title: that.$l('table_label_displaySales') || '售卖标题',
    field: 'salesTitle',
    minWidth: 250,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displaySales' },
  },
  {
    title: that.$l('table_label_displayPlatform') || '渠道',
    field: 'platformName',
    minWidth: 200,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayPlatform' },
  },
  {
    title: that.$l('table_label_displayScm') || '工厂',
    field: 'scmName',
    minWidth: 200,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayScm' },
  },
]
